export default __webpack_public_path__ + "static/media/plain-sticker-O.dd7bebb0.png";